import {
  CartesianGrid,
  Legend,
  Line,
  LineChart,
  XAxis,
  YAxis,
  Area,
} from "recharts";
import { BsDot } from "react-icons/bs";

export const RenderLegend = (props) => {
  const { lines } = props;
  return (
    <div className="d-flex justify-content-center mb-1">
      {lines.map((entry, index) => (
        <div>
          {/* <FaSquareFull className="mx-2" size={18} color={colors[index]} /> */}
          <BsDot size={40} color={entry.fill} />
          <span
            className="ml-1 "
            key={`item-${index}`}
            style={{ fontFamily: "Poppins, serif", fontSize: "12px" }}
          >
            {entry.name}
          </span>
        </div>
      ))}
    </div>
  );
};

const CustomLineChart = ({
  data,
  width,
  height,
  lines,
  lineType = "linear",
  showLegend = true,
}) => {
  return (
    <LineChart width={width} height={height} data={data}>
      <CartesianGrid strokeDasharray="3 5" strokeWidth={0.5} />
      <XAxis
        dataKey="name"
        fontFamily="Poppins, serif"
        fontSize={"12px"}
        interval={0}
      />
      <YAxis fontFamily="Poppins, serif" fontSize={"12px"} />
      {showLegend ? (
        <Legend
          verticalAlign="top"
          align="center"
          style={{ marginBottom: "8px", fontFamily: "Poppins, serif" }}
          content={<RenderLegend lines={lines} />}
        />
      ) : (
        <></>
      )}
      {lines.map((line, index) => (
        <Line
          type={lineType}
          name={line.name}
          dataKey={line.key}
          activeDot={{ r: 8 }}
          strokeWidth={2}
          stroke={line.fill}
          key={index}
        />
      ))}
    </LineChart>
  );
};

export default CustomLineChart;
